import {Injectable, effect, inject} from '@angular/core'
import type {CustomLiteralEntry} from '@models/custom-literals.models'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {CustomLiteralsService} from './custom-literals.service'

@Injectable({providedIn: 'root'})
export class CustomLiteralsEmbeddedService extends CustomLiteralsService {
  private readonly embeddedStoreService = inject(EmbeddedStoreService)

  constructor() {
    super()
    effect(() => {
      if (this.embeddedStoreService.customLiterals()) this.apply()
    })
  }

  protected override async getLiterals(): Promise<CustomLiteralEntry[] | null> {
    return this.embeddedStoreService.customLiterals()
  }
}
